import Image from '@base/Image';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import styleHelper from '@utils/styleHelper';
import EducatorAvatarWithTopicColor from '@icon/EducatorAvatarWithTopicColor';

const Wrapper = styled.div`
  width: 60px;
  height: 60px;
  margin-right: ${Spacings.SPACING_6};
  margin-left: ${Spacings.SPACING_6};
  display: grid;
  place-items: center;
  position: relative;
  margin-top: ${Spacings.SPACING_6};
  margin-bottom: ${Spacings.SPACING_6};
  background-color: ${(props) =>
    props.$bgColor ? props.$bgColor : 'transparent'};
  border-radius: 50%;
`;

const EducatorImage = styled(Image)`
  border-radius: 50%;
  object-fit: cover;
  object-position: top;
`;

const BigCircle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.$bgColor ? props.$bgColor : 'transparent'};

  position: absolute;
  top: -5px;
  left: 43px;
`;

const SmallCircle = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.$bgColor ? props.$bgColor : 'transparent'};

  position: absolute;
  top: 23px;
  left: -4px;
`;

const EducatorAvatar = ({ avatar, circleColor }) => {
  const getBgColor = (intensity) => {
    if (circleColor === 'var(--color-i-black)')
      return 'var(--color-i-black-light-25)';
    return styleHelper.hexToRgb(circleColor, intensity);
  };

  return (
    <Wrapper $bgColor={getBgColor(0.2)}>
      {avatar ? (
        <EducatorImage src={avatar} width={60} height={60} alt="avatar" />
      ) : (
        <EducatorAvatarWithTopicColor
          iconBgColor={getBgColor(0.3)}
          bgColor={getBgColor(0.2)}
          strokeColor={getBgColor(0.7)}
        />
      )}
      <SmallCircle $bgColor={circleColor} />
      <BigCircle $bgColor={circleColor} />
    </Wrapper>
  );
};

export default EducatorAvatar;
